<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xv8FLi/tc-custom/9781460349144.jpg?1718282942518" alt="This image is the cover for the book Emerald Mistress"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emerald Mistress
      </h1>
      <p class="bookDescription body article font2">
        <b>An international tycoon shakes up a woman’s plans for a fresh start in an Irish village in this classic romantic comedy by a <i>USA Today</i>–bestselling author.</b><br/><br/>When Harriet Carmichael’s world comes crashing down, she’s determined to count her blessings. Forget London, her failing career and her unfaithful fiancé—an unexpected legacy of a cottage and stables in an Irish village beckons!<br/><br/>But her fresh start is soon threatened by Rafael Cavaliere: her new neighbour and the very man who cost Harriet her job! With her heart so recently burned she’s reluctant to become another notch on his bedpost, but when passion ensnares them both, deep secrets are revealed—ones that could change their lives forever.<br/><br/><b>Originally published in 2002 as<i> Ballyflynn</i>, now available digitally for the first time<i>.</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Graham
      </h2>
      
      <p class="authorDescription body article">Lynne Graham lives in Northern Ireland and has been a keen romance reader since her teens. Happily married, Lynne has five children. Her eldest is her only natural child. Her other children, who are every bit as dear to her heart, are adopted. The family has a variety of pets, and Lynne loves gardening, cooking, collecting allsorts and is crazy about every aspect of Christmas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?632f3fb6